export const SET_LOADING = "SET_LOADING";
export const SET_LOADING_TEXT = "SET_LOADING_TEXT";
export const SET_LIST_LOADING = "SET_LIST_LOADING";
export const SET_DOWNLOAD_LOADING = "SET_DOWNLOAD_LOADING";

export const SET_FIELD_MAPPING_TIMEOUT_ID = "SET_FIELD_MAPPING_TIMEOUT_ID";

export const SET_ERRORS = "SET_ERRORS";

export const SET_UPLOAD_DATA = "SET_UPLOAD_DATA";
export const SET_UPLOAD_FILE = "SET_UPLOAD_FILE";
export const SET_REVIEW_DATA = "SET_REVIEW_DATA";

export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_MAPPED_COLUMNS = "SET_MAPPED_COLUMNS";
export const SET_ADDITIONAL_COLUMNS = "SET_ADDITIONAL_COLUMNS";
export const SET_SELECTED_COLUMNS = "SET_SELECTED_COLUMNS";

export const SET_STEPVAL = "SET_STEPVAL";
export const RESET_UPLOAD_FORM = "RESET_UPLOAD_FORM";

export const CHANGE_FILE_REQUEST = "CHANGE_FILE_REQUEST";
export const CHANGE_FILE_SUCCESS = "CHANGE_FILE_SUCCESS";
export const CHANGE_FILE_FAILURE = "CHANGE_FILE_FAILURE";

export const LOAD_PAGE_DATA = "LOAD_PAGE_DATA";
export const LOAD_PAGE_DATA_SUCCESS = "LOAD_PAGE_DATA_SUCCESS";
export const LOAD_PAGE_DATA_FAILURE = "LOAD_PAGE_DATA_FAILURE";

export const GET_UPLOAD_LOGS = "GET_UPLOAD_LOGS";
export const GET_UPLOAD_LOGS_SUCCESS = "GET_UPLOAD_LOGS_SUCCESS";
export const GET_UPLOAD_LOGS_FAILURE = "GET_UPLOAD_LOGS_FAILURE";

export const GET_UPLOAD_LOG_DATA = "GET_UPLOAD_LOG_DATA";
export const GET_UPLOAD_LOG_DATA_SUCCESS = "GET_UPLOAD_LOG_DATA_SUCCESS";
export const GET_UPLOAD_LOG_DATA_FAILURE = "GET_UPLOAD_LOG_DATA_FAILURE";

export const VIEW_UPLOAD_LOG = "VIEW_UPLOAD_LOG";
export const VIEW_UPLOAD_LOG_SUCCESS = "VIEW_UPLOAD_LOG_SUCCESS";
export const VIEW_UPLOAD_LOG_FAILURE = "VIEW_UPLOAD_LOG_FAILURE";

export const UPLOAD_FILES = "UPLOAD_FILES";
export const UPLOAD_FILES_SUCCESS = "UPLOAD_FILES_SUCCESS";
export const UPLOAD_FILES_FAILURE = "UPLOAD_FILES_FAILURE";

export const GET_MAPPED_FIELDS = "GET_MAPPED_FIELDS";
export const GET_MAPPED_FIELDS_SUCCESS = "GET_MAPPED_FIELDS_SUCCESS";
export const GET_MAPPED_FIELDS_FAILURE = "GET_MAPPED_FIELDS_FAILURE";

export const SET_FILTERS = "SET_FILTERS";

export const GET_PROJECTS_FOR_MASTER = "GET_PROJECTS_FOR_MASTER";
export const GET_PROJECTS_FOR_MASTER_SUCCESS = "GET_PROJECTS_FOR_MASTER_SUCCESS";
export const GET_PROJECTS_FOR_MASTER_FAILURE = "GET_PROJECTS_FOR_MASTER_FAILURE";

export const RUN_ETL_PROCESS = "RUN_ETL_PROCESS";
export const RUN_ETL_PROCESS_SUCCESS = "RUN_ETL_PROCESS_SUCCESS";
export const RUN_ETL_PROCESS_FAILURE = "RUN_ETL_PROCESS_FAILURE";

export const REJECT_REVIEW = "REJECT_REVIEW";
export const REJECT_REVIEW_SUCCESS = "REJECT_REVIEW_SUCCESS";
export const REJECT_REVIEW_FAILURE = "REJECT_REVIEW_FAILURE";

export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const DOWNLOAD_FILE_SUCCESS = "DOWNLOAD_FILE_SUCCESS";
export const DOWNLOAD_FILE_FAILURE = "DOWNLOAD_FILE_FAILURE";

export const UPDATE_METADATA = "UPDATE_METADATA";
export const UPDATE_METADATA_SUCCESS = "UPDATE_METADATA_SUCCESS";
export const UPDATE_METADATA_FAILURE = "UPDATE_METADATA_FAILURE";
